import React from "react";

interface IconProps {
  className?: string;
}

const LinkedInIcon: React.FC<IconProps> = ({ className }) => (
  <svg
    viewBox="0 0 24 24"
    fill="currentColor"
    role="img"
    aria-hidden="true"
    className={className}
  >
    <path d="M20.447 20.452H16.89v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.345V9h3.414v1.561h.047c.477-.9 1.637-1.85 3.37-1.85 3.6 0 4.266 2.368 4.266 5.455v6.286zM5.337 7.433c-1.144 0-2.067-.926-2.067-2.065 0-1.138.923-2.064 2.067-2.064 1.14 0 2.064.926 2.064 2.064 0 1.139-.924 2.065-2.064 2.065zM6.917 20.452H3.757V9h3.16v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
  </svg>
);

export default LinkedInIcon;
